export default __webpack_public_path__ + "static/media/logoPUC.efc4b6d3.png";